import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { FEATURES } from '../../data/conjointData';
import { GRID_PROPS, Y_AXIS_PROPS, TOOLTIP_STYLE, CHART_COLORS } from '../../styles/chart-theme';
import { InfoButton } from '../common/Tooltip';
import { useIsMobile } from '../../hooks/useIsMobile';

export function FeatureLiftChart() {
  const isMobile = useIsMobile();
  const data = FEATURES.map(f => ({ name: f.name, lift: f.lift * 100, selections: f.selections }));
  const maxLift = Math.max(...data.map(d => d.lift));

  return (
    <div className="card">
      <div className="flex items-center gap-2 mb-4">
        <h3 className="text-heading font-semibold text-secondary uppercase tracking-wider">Feature Value Impact</h3>
        <InfoButton helpKey="featureLiftRanking" size={13} />
      </div>
      <ResponsiveContainer width="100%" height={isMobile ? 220 : 300}>
        <BarChart data={data} layout="vertical" margin={{ top: 5, right: 40, left: 140, bottom: 5 }}>
          <CartesianGrid {...GRID_PROPS} horizontal={false} vertical />
          <XAxis type="number" tick={{ fill: 'var(--color-axis-tick)', fontSize: 12 }} tickFormatter={v => `${v.toFixed(0)}%`} domain={[0, 'auto']} />
          <YAxis type="category" dataKey="name" {...Y_AXIS_PROPS} width={130} tick={{ fill: 'var(--color-text-primary)', fontSize: 12 }} />
          <Tooltip {...TOOLTIP_STYLE} formatter={(value: number) => [`${value.toFixed(1)}%`, 'Lift']} />
          <Bar dataKey="lift" radius={[0, 4, 4, 0]} maxBarSize={24}>
            {data.map((entry, i) => <Cell key={i} fill={CHART_COLORS.teal} fillOpacity={0.4 + 0.6 * (entry.lift / maxLift)} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <div className="mt-4 grid grid-cols-2 gap-2 text-xs">
        {FEATURES.map(f => (
          <div key={f.name} className="flex items-center justify-between text-secondary px-2">
            <span className="truncate">{f.name}</span>
            <span className="font-mono ml-2 text-muted">{f.selections.toLocaleString()} sel</span>
          </div>
        ))}
      </div>
    </div>
  );
}
